// extracted by mini-css-extract-plugin
export default {"chips":"Chips_chips__ImTbx","chip":"Chips_chip__uvolW","btnRemove":"Chips_btnRemove__xNCny","btnRemoveAll":"Chips_btnRemoveAll__xWPah"};